export const generatePrompt = (formData: {
  topic: string; // What the text is about
  tone: string; // Tone of the text
  length: string; // Length of the text (e.g., short, medium, long)
  language: string; // Language of the output
}): string => {
  // Destructure the inputs from the form
  const { topic, tone, length, language } = formData;

  // Create a template for the OpenAI prompt
  const template = `
  Task:
${topic}
--> If in the task description is only mentioned a topic, just write a text about this topic.
---
Format-Rules:
- Length:  ${length}
- Output-Language: ${language}
- Tonality: ${tone} 
---
Rules:
- ensure the generated text is clear, engaging, and aligned with these instructions. 
- no explanations; no introductory sentences;
  `;

  // Return the dynamically generated prompt
  return template.trim();
};
